
import {
    NEW_USERS_START,
    NEW_USERS_SUCCESS,
    NEW_USERS_FILED,
} from "../action-types/actionTypes";


const initialState = {
    loading: false,
    newUsersData: null,
    error: null,
  }

export function newUsersReducer(state = initialState, action) {
    switch (action.type) {
        case NEW_USERS_START:
            return {
                ...state,
                loading: true
            }
        case NEW_USERS_SUCCESS:
            return {
                ...state,
                loading: false,
                newUsersData: action.payload
            }
        case NEW_USERS_FILED:
            return {
                ...state,
                loading: false,
                error: 'samething went wrong',
            }
        default:
            return state;
    }
}